//#region ../schema-sql-parser/dist/parser/dataType/MSSQL.js
var MSSQLTypes = [
	"BIGINT",
	"BINARY VARYING",
	"BINARY",
	"BIT",
	"CHAR VARYING",
	"CHAR",
	"CHARACTER VARYING",
	"CHARACTER",
	"DATE",
	"DATETIME",
	"DATETIME2",
	"DATETIMEOFFSET",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"FLOAT",
	"GEOGRAPHY",
	"GEOMETRY",
	"HIERARCHYID",
	"IMAGE",
	"INT",
	"INTEGER",
	"JSON",
	"MONEY",
	"NATIONAL CHAR VARYING",
	"NATIONAL CHAR",
	"NATIONAL CHARACTER VARYING",
	"NATIONAL CHARACTER",
	"NATIONAL TEXT",
	"NCHAR",
	"NTEXT",
	"NUMERIC",
	"NVARCHAR",
	"REAL",
	"ROWVERSION",
	"SMALLDATETIME",
	"SMALLINT",
	"SMALLMONEY",
	"SQL_VARIANT",
	"TEXT",
	"TIME",
	"TIMESTAMP",
	"TINYINT",
	"UNIQUEIDENTIFIER",
	"VARBINARY",
	"VARCHAR",
	"VECTOR",
	"XML"
];
//#endregion
export { MSSQLTypes };
